import SelectSearchable from "../../SelectSeachble/SelectSearchble";
import { tituloClinico } from "../../../utils/textoClinico";
import { montoLegible } from "../../../utils/facturaCrear";
import "../../../styles/FacturaCrear.css";

/* ============================================================================
   CREAR FACTURA · el cuerpo del modal de emisión

   Sólo la PRESENTACIÓN. El estado, `handleBilling`, la clave de idempotencia y
   la condición del vendedor siguen en `ConfirmBilling`: aquí no hay ni un
   `useState` ni una llamada a servicio.

   Qué cambia respecto al modal actual:
   · Los dos botones mudos ("FACTURA" / "COMPROBANTE") pasan a ser dos opciones
     CON su explicación. La diferencia está verificada en el código y en los
     datos, no inventada:
       - cada tipo lleva su propio contador en `facturas_sequences`, que
         cuenta por (clínica, establecimiento, punto de emisión, documento);
       - sólo la FACTURA se envía a Contífico. El comprobante funciona como
         ingreso de caja: se guarda y ya.
   · El vendedor obligatorio se marca cuando falta, en vez de dejar el botón
     apagado sin decir nada.
   · Bloque "Se va a emitir": última oportunidad de ver un error antes de una
     acción irreversible.
   ========================================================================== */

const TIPOS = [
    {
        clave: "FAC",
        titulo: "Factura",
        detalle: "Documento fiscal. Se envía a Contífico y lleva su propia numeración.",
    },
    {
        clave: "COM",
        titulo: "Comprobante",
        detalle: "Ingreso de caja. Numeración propia y NO se envía a Contífico.",
    },
];

export default function CuerpoEmitir({
    selected,
    onSelect,
    disabled,
    vendedores,
    selectedVendedorOption,
    onVendedor,
    faltaVendedor,
    paciente,
    procedimientos,
    formasPago,
    total,
}) {
    return (
        <>
            <fieldset className="femitir__tipos">
                <legend className="fcrear__lab">Tipo de documento</legend>
                {TIPOS.map((t) => (
                    <label
                        key={t.clave}
                        className={`femitir__tipo${selected === t.clave ? " femitir__tipo--activo" : ""}${disabled ? " femitir__tipo--off" : ""}`}
                    >
                        <input
                            type="radio"
                            name="tipo-documento"
                            checked={selected === t.clave}
                            onChange={() => onSelect(t.clave)}
                            disabled={disabled}
                        />
                        <span>
                            <span className="femitir__tipo-titulo">{t.titulo}</span>
                            <span className="femitir__tipo-detalle">{t.detalle}</span>
                        </span>
                    </label>
                ))}
            </fieldset>

            <div className="femitir__campo">
                <label className="fcrear__lab" htmlFor="emitir-vendedor">
                    Vendedor <span className="femitir__req">*</span>
                </label>
                <div id="emitir-vendedor" className={faltaVendedor ? "femitir__invalido" : undefined}>
                    <SelectSearchable
                        listCompany={vendedores}
                        handleChange={onVendedor}
                        placeholder="Seleccione"
                        selectedOption={selectedVendedorOption}
                        isClearable={true}
                    />
                </div>
                {faltaVendedor && (
                    <p className="femitir__error">Obligatorio para emitir el documento</p>
                )}
            </div>

            {/* Última oportunidad de detectar un error: emitir no se deshace. */}
            <div className="femitir__revision">
                <p className="fcrear__lab">Se va a emitir</p>
                <dl className="femitir__lista">
                    <div className="femitir__par">
                        <dt>Cliente</dt>
                        <dd>{tituloClinico(paciente || "") || "—"}</dd>
                    </div>
                    <div className="femitir__par">
                        <dt>Detalle</dt>
                        <dd>
                            {procedimientos.length} procedimiento
                            {procedimientos.length === 1 ? "" : "s"}
                        </dd>
                    </div>
                    <div className="femitir__par">
                        <dt>Forma de pago</dt>
                        <dd>
                            {formasPago.length === 0
                                ? "Sin registrar"
                                : formasPago.map((p) => p.label).join(", ")}
                        </dd>
                    </div>
                    <div className="femitir__par femitir__par--total">
                        <dt>Total</dt>
                        <dd>${montoLegible(total)}</dd>
                    </div>
                </dl>
            </div>
        </>
    );
}
